import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import SortingHeader from '../../../components/common/sorting-header';
import styles from './sticky-header.styles';

function StickyHeader({ messages }) {
  return (
    <View style={styles.rootBorder}>
      <SortingHeader
        options={[
          {
            label: 'app.report.transactionHistory.tradeDate',
            key: 'tradeDate',
            width: 0.2,
            isPhone: true,
            isTablet: true,
          },
          {
            label: 'app.report.transactionHistory.type',
            key: 'type',
            width: 0.2,
            isPhone: true,
            isTablet: true,
          },
          {
            label: 'app.report.transactionHistory.amount',
            key: 'amount',
            width: 0.65,
            isPhone: true,
            isTablet: true,
          },
        ]}
        messages={messages}
      />
    </View>
  );
}

StickyHeader.propTypes = {
  showBorder: PropTypes.bool,
};

StickyHeader.defaultProps = {
  showBorder: true,
};

export default pure(StickyHeader);
